import axios from '../axios';

const fetchTasks = (setTasks, mission) => {
    axios.get(`${'tasks'}`, { params: { missionId: mission } }).then(
        (res) => {
            // console.log(res.data);
            setTasks(res.data);
        },
        (err) => {
            console.error('error in getting Tasks', err);
        }
    );
};

const fetchStatusTasks = (setTasks, mission, status) => {
    axios.get(`${'tasks'}`, { params: { missionId: mission, status: status } }).then(
        (res) => {
            console.log(res.data);
            setTasks(res.data);
        },
        (err) => {
            console.error('error in getting status Tasks', err);
        }
    );
};
const fetchExpertTasks = (setTasks, mission, expertId) => {
    axios.get(`${'tasks'}`, { params: { missionId: mission, expertId: expertId } }).then(
        (res) => {
            console.log(res.data);
            setTasks(res.data);
        },
        (err) => {
            console.error('error in getting expert Tasks', err);
        }
    );
};

const createTask = (formValues) => {
    axios.post(`${'tasks'}`, formValues).then(
        (res) => {
            console.log(res.data);
        },
        (err) => {
            console.error(err);
        }
    );
};

const updateTask = (taskId, updates) => {
    axios.put(
        `${'tasks'}` + '/' + `${taskId}`, updates
    ).then(
        (res) => {
            console.log(res.data);
            return res.data;
        },
        (err) => {
            console.error(err);
        }
    );
};

export { createTask, fetchExpertTasks,fetchStatusTasks, fetchTasks, updateTask };
